import { IconProps } from "../../utils/global-types/global-types";

const UserSingleIcon = ({ className, ...rest }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 18 18"
    className={className ? className : "w-5 h-5"}
    {...rest}
  >
    <g fill="currentColor" clipPath="url(#clip0_6096_60311)">
      <path d="M9.25 2a3.566 3.566 0 0 0-3.562 3.563c0 1.927 1.507 3.487 3.472 3.555a.6.6 0 0 1 .165 0h.052a3.554 3.554 0 0 0 3.435-3.556A3.566 3.566 0 0 0 9.25 2M13.06 11.113c-2.093-1.396-5.505-1.396-7.613 0-.952.637-1.477 1.5-1.477 2.422s.525 1.777 1.47 2.408C6.49 16.648 7.87 17 9.25 17s2.76-.352 3.81-1.057c.945-.638 1.47-1.493 1.47-2.423-.007-.922-.525-1.777-1.47-2.407"></path>
    </g>
    <defs>
      <clipPath id="clip0_6096_60311">
        <path fill="#fff" d="M0 0h18v18H0z"></path>
      </clipPath>
    </defs>
  </svg>
);

export default UserSingleIcon;
